import { render, staticRenderFns } from "./PedidoFinalizado.vue?vue&type=template&id=a459aac8&"
import script from "./PedidoFinalizado.vue?vue&type=script&lang=js&"
export * from "./PedidoFinalizado.vue?vue&type=script&lang=js&"
import style0 from "./PedidoFinalizado.vue?vue&type=style&index=0&id=a459aac8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports